import { Trans } from "@lingui/macro";
import { formatNumber, formatToEuro } from "@ster/ster-toolkit";
import classNames from "classnames";

import usePortalSettings from "../../portalSettings/usePortalSettings";
import styles from "./BookSpotFooter.module.less";

type BookSpotBalanceStatusRegionalProps = {
  balanceMutation: number;
};

type BookSpotBalanceStatusNationalProps = BookSpotBalanceStatusRegionalProps & {
  balance: number;
  grpBalance?: number;
  grpBalanceMutation?: number;
};

type BookSpotBalanceStatusProps = BookSpotBalanceStatusRegionalProps &
  BookSpotBalanceStatusNationalProps;

const BookSpotBalanceStatusNational = ({
  balance,
  grpBalance = 0,
  balanceMutation,
  grpBalanceMutation = 0,
}: BookSpotBalanceStatusNationalProps) => {
  const total = balance + balanceMutation;
  const totalGrp = grpBalance + grpBalanceMutation;

  return (
    <>
      {total > 0 ? <Trans>Overscore</Trans> : <Trans>Onderscore</Trans>}:{" "}
      <span
        className={classNames(
          {
            [styles.overscore]: total > 0,
          },
          {
            [styles.underscore]: total <= 0,
          }
        )}
      >
        {formatToEuro(total, false)} ({formatNumber(totalGrp, 2)} GRP&apos;s)
      </span>
    </>
  );
};

const BookSpotBalanceStatusRegional = ({
  balanceMutation,
}: BookSpotBalanceStatusRegionalProps) => (
  <>
    <Trans>Mutatie</Trans>:{" "}
    <span>
      {formatToEuro(Math.abs(balanceMutation), false)}{" "}
      {balanceMutation > 0 && <Trans>bijgeboekt</Trans>}
      {balanceMutation <= 0 && <Trans>afgeboekt</Trans>}
    </span>
  </>
);

const BookSpotBalanceStatus = ({ ...props }: BookSpotBalanceStatusProps) => {
  const {
    settings: { isRegional, isNational },
  } = usePortalSettings();

  if (isRegional) {
    return <BookSpotBalanceStatusRegional {...props} />;
  }

  if (isNational) {
    return <BookSpotBalanceStatusNational {...props} />;
  }

  return null;
};

export default BookSpotBalanceStatus;
